<ng-container *ngIf="step">
  <div *ngIf="active" class="progress-stepper-item">
    <div *ngIf="step.reminderTitle" class="progress-stepper__reminder">
      <smart-fix-reminder-text
        [border]="true"
        [description]="step.reminderText"
        [iconName]="'circle-info'"
        [theme]="step.reminderTheme || 'background'"
        [title]="step.reminderTitle"
      />
    </div>
    <dgx-components-rich-text
      *ngIf="step.stepDescription"
      [content]="step.stepDescription"
    />

    <div *ngIf="step.applianceImage.src" class="progress-stepper__picture">
      <dgx-components-picture
        [alt]="step.applianceImage.alt"
        [aspectRatio]="step.applianceImage.aspectRatio"
        [position]="step.applianceImage.position"
        [src]="step.applianceImage.src"
      />
    </div>
    <ng-content></ng-content>
  </div>
</ng-container>
